import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AutenticacaoService } from 'app/services/autenticacao.service';
import { HostnameService } from 'app/services/hostname.service';
import { environment } from 'environments/environment';

export const authGuard: CanActivateFn = () => {
    const autenticacaoService = inject(AutenticacaoService);
    const router = inject(Router);
    const hostnameService = inject(HostnameService);

    if (autenticacaoService.isAuthenticated()) {
        return true;
    }

    // In production on landing domain, redirect to app domain login
    if (environment.production && !hostnameService.isAppDomain()) {
        window.location.href = hostnameService.getAppUrl('/login');
        return false;
    }

    router.navigateByUrl('/login');
    autenticacaoService.logout();
    return false;
};
